/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { transactionLaneDataHandle } from "../state/actions";
import { Tooltip, Button, Menu, Dropdown, Image } from "antd";
import newStyles from "../style/RtdRow.module.css";
import { Modal, Spin } from "antd";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { FilePdfOutlined, CheckCircleFilled, MessageTwoTone, ExclamationCircleOutlined ,SettingOutlined, DeleteTwoTone, FileImageOutlined, MoreOutlined, CloudUploadOutlined} from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import { offerTableHandle } from "../../OfferTable/state/actions";
import { createOfferContractTypes, disabledTransactionText } from "../../Common/commondata/commonData";
import UploadPdfDoc from "./UploadPdfDoc";
import ContractTypeBadge from "../../Common/components/ContractTypeBadge";
import ResureSign from "../../Assets/Icons/Resure_icon.png";

const SignalIcon = ({ source, documentStatus }) => {
  const { buyerSignStatus, buyerAgentSignStatus, sellerSignStatus, sellerAgentSignStatus, signatureSequence } = documentStatus || {};
  const getStatusColor = (status) => {
    switch (status) {
      case "SUBMITTED":
        return "green";
      case "DRAFT":
        return "white";
      case "INPROGRESS":
        return "yellow";
      default:
        return "white";
    }
  };
  let topColor, bottomColor, fullColor, indicatorNotRequired;
  if (source === "BUYER") {
    if (signatureSequence?.buyer && signatureSequence?.buyerAgent) {
      topColor = getStatusColor(buyerSignStatus);
      bottomColor = getStatusColor(buyerAgentSignStatus);
    } else if (signatureSequence?.buyer) {
      fullColor = getStatusColor(buyerSignStatus);
    } else if (signatureSequence?.buyerAgent) {
      fullColor = getStatusColor(buyerAgentSignStatus);
    } else {
      // fullColor = getStatusColor();
      indicatorNotRequired = true;
    }
  } else if (source === "SELLER") {
    if (signatureSequence?.seller && signatureSequence?.sellerAgent) {
      topColor = getStatusColor(sellerSignStatus);
      bottomColor = getStatusColor(sellerAgentSignStatus);
    } else if (signatureSequence?.seller) {
      fullColor = getStatusColor(sellerSignStatus);
    } else if (signatureSequence?.sellerAgent) {
      fullColor = getStatusColor(sellerAgentSignStatus);
    } else {
      // fullColor = getStatusColor();
      indicatorNotRequired = true;
    }
  }
  // console.log(source, documentStatus.contractType, topColor, bottomColor, fullColor);
  if (indicatorNotRequired) {
    return null;
  }
  return (
    <div className={newStyles.signalIconOutline}>
      <div
        className={fullColor ? newStyles.fullIndicator : newStyles.signalIndicator}
        style={{
          "--topColor": topColor,
          "--bottomColor": bottomColor,
          "--fullColor": fullColor,
        }}
      />
    </div>
  );
};

const SellerComp = (props={}) => {
  let timestamp = (props.RTDInitiator === "SELLER") ? (props.dateSubmitted || props.sentDateMili) : props.latestDocumentSignatureAt;
  let toolTipMessage = timestamp && (props.RTDInitiator === "SELLER") ? `Date the document was ${props?.isSharedDoc ? "shared" : "sent"} to the Buyer Agent.` : "Date the last required signer from the buying side signed the document.";
  let date = timestamp && new Date(timestamp);
  const dateNew = timestamp && moment(date).format("MM/DD/YYYY");
  const time = timestamp && moment(date).format("h:mm a");
  const signalRequired = props?.signatureSequence?.seller || props.signatureSequence?.sellerAgent
  const {  checkForDisable } = useSelector((state) => state.offerTable);
  const dispatch = useDispatch();
  const { confirm } = Modal;
  const { URLofferTableJSON } = useSelector((state) => state.offerTable);
  const sellerOpenOfferTable = URLofferTableJSON?.urlData?.sellerOpenOfferTable;
  const confirmDeleteForm = (props) => {
    confirm({
      title:  "Are you sure you want to rescind this document?",
      content: "Note: This document will be removed from the Transaction Dashboard and will only be accessible from the Property Docs folder.",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        if (props?.documentId) {
          const payloadData = {
            documentId: props?.documentId,
            ...(props?.selectedData?.offerId && { offerId: props?.selectedData?.offerId }),
            token: props?.userAuthKey,
            role: props?.RTDInitiator,
            ...(props?.isResureSignDoc ? { isResureSignDoc: true, showInTransactionDashboard: false } : {}),
            isToggleFrom: "PRE_RTD",
            openFor: "SELLER_AGENT"
          };
          dispatch(transactionLaneDataHandle.deletePropertyContractDocs({ payloadData }));
        }
      },
      onCancel() {
        // Do nothing, just close the Modal
      },
    });
  };
  const canPRERTDDOCBeDeleted = () => {
    if (sellerOpenOfferTable) return false;
    if(props?.isSharedDoc) return false
    if (props?.RTDInitiator !== "SELLER") return false;
    // if (counterOfferContractTypes.includes(props?.contractType) && props?.sellerSignStatus === "SUBMITTED" && props?.buyerSignStatus === "SUBMITTED") return false;
    return true;
  };
  
  return (
    <div className={newStyles.sellerCompContainer}>
      <div className={newStyles.sellerCenterline}>
        <>
          <div
            style={{
              width: "100%",
              position: "relative",
              borderStyle: props.RTDInitiator === "SELLER" ? "solid" : "none",
              height: 0,
              marginTop: signalRequired ? 3 : 5,
              borderColor: props?.RTDInitiator === "SELLER" ? (props?.invalidated ? "darkgray" : "#2976be") : "white",
            }}
          >
            {props?.RTDInitiator === "SELLER" &&
              props?.client === "SELLER" &&
              (props?.checked?.showBuyer || props?.isSharedDoc ? (
                <span style={{ position: "absolute", top: "50%", transform: "translateY(-50%)" }}>
                  <Tooltip title={`Document ${props?.isSharedDoc ? "shared" : "sent"} to Buyer Agent`}>
                    <CheckCircleFilled style={{ fontSize: props?.isSmallScreen ? "14px" : "18px", backgroundColor: "white", borderRadius: "100px", color: props?.invalidated ? "darkgray" : "green" }} />
                  </Tooltip>
                </span>
              ) : (
                <></>
              ))}

            <div className={newStyles.dateAndTimeSeller}>
              {timestamp && (
                <div style={{ display: "inline-block" }}>
                  <Tooltip title={toolTipMessage} placement="top">
                    <p
                      className={newStyles.newdateSeller}
                      style={{
                        marginTop: props?.RTDInitiator === "BUYER" ? "-30px" : "0px",
                      }}
                    >
                      {dateNew}
                    </p>
                    <p className={newStyles.newtimeSeller}>{time}</p>
                  </Tooltip>
                </div>
              )}
            </div>
            {props?.isSharedDoc && props?.RTDInitiator === "SELLER" ? <div style={{ position: "absolute", bottom: 5, left: 0, cursor: "pointer", fontWeight: 600, width: "45%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Shared By {props?.sharedBy?.fullName || ""}</div> : null}
            {canPRERTDDOCBeDeleted() && (
              <div style={{ position: "absolute", bottom: 0, left: 0, cursor: "pointer" }} {...(checkForDisable?.disabled ? { onClick: disabledTransactionText } : { onClick: () => confirmDeleteForm(props) })}>
                <Tooltip title="Delete Document">
                  <DeleteTwoTone />
                </Tooltip>
              </div>
            )}
          </div>
          <SignalIcon source="SELLER" documentStatus={props} />
        </>
      </div>
    </div>
  );
};

const BuyerComp = (props={}) => {
  let timestamp = (props.RTDInitiator === "BUYER") ? (props.dateSubmitted || props.sentDateMili) : props.latestDocumentSignatureAt;
  let toolTipMessage = timestamp && (props.RTDInitiator === "BUYER") ? `Date the document was ${props?.isSharedDoc ? "shared" : "sent"} to the Seller Agent.` : "Date the last required signer from the selling side signed the document.";
  let date = timestamp && new Date(timestamp);
  const dateNew = timestamp && moment(date).format("MM/DD/YYYY");
  const time = timestamp && moment(date).format("h:mm a");
  const signalRequired = props?.signatureSequence?.buyer || props.signatureSequence?.buyerAgent

return (
    <div className={newStyles.buyerCompContainer}>
      <div className={newStyles.buyerCenterLine}>
        <>
           <SignalIcon source="BUYER" documentStatus={props} />
          <div
            style={{
              width: "100%",
              position: "relative",
              borderStyle: props.RTDInitiator === "BUYER" ? "solid" : "none",
               height: 0,
               marginTop: signalRequired ? 3 : 5,
              borderColor: props.RTDInitiator === "BUYER" ? (props?.invalidated ? "darkgray" : "#ffce51") : "white",
            }}
          >
            {props.RTDInitiator === "BUYER" &&
              props.client === "BUYER" &&
              ((props.checked.showSeller || props?.isSharedDoc) ? (
                <span style={{ position: "absolute", top: "50%", transform: "translateY(-50%)" }}>
                  <Tooltip title={`Document ${props?.isSharedDoc ? "shared" : "sent"} to Seller Agent`}>
                    <CheckCircleFilled style={{ fontSize: props?.isSmallScreen?"14px":"18px", backgroundColor: "white", borderRadius: "100px", color: props.invalidated ? "darkgray" : "green" }} />
                  </Tooltip>
                </span>
              ) : (
                <></>
              ))}
            {(props?.isSharedDoc && props?.RTDInitiator === "BUYER") ? (
              <div style={{ position: "absolute", bottom: 5, right: 0, cursor: "pointer", fontWeight: 600, width: "45%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                Shared By {props?.sharedBy?.fullName || ""}
              </div>
            ) : null}
            <div className={newStyles.dateAndTimeBuyer}>
              {timestamp && <div style={{display: "inline-block"}}>
                <Tooltip title={toolTipMessage} placement="top">
                  <p
                  className={newStyles.newdateBuyer}
                    style={{
                      marginTop: props?.RTDInitiator === "BUYER" ? "-5px" : "-30px",
                      }}
                  >
                    {dateNew}
                  </p>
                  <p
                    className={newStyles.newtimeBuyer}
                  >
                    {time}
                  </p>
                </Tooltip>
              </div>}
            </div>
          </div>
        </>
      </div>
    </div>
  );
};

const DetailComp = ({ doc, seller, role, selectedData, ispdfClone,isResureSignDoc, userAuthKey, handleCheckboxChangeBuyer, isSmallScreen, isMediumScreen, allBuyerAgentData, updatedName }) => {
  let dispatch = useDispatch();
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const [allData, setAllData] = useState({
      uploadPdfDoc: false,
      file: "",
    });
  const { URLofferTableJSON, currentSellerAgentData, offerTableAuthKey,offerTablePropertyId } = useSelector((state) => state.offerTable);
  let sellerOpenOfferTable = URLofferTableJSON?.urlData?.sellerOpenOfferTable;

  const urlShortningForDraft = () => {
    if (seller?.ispdfClone || seller?.isPdf || (seller?.fileType === "IMAGE") || (seller?.fileType === "PDF")) {
      let fileUrl = seller?.resureSignedPdfLink ? seller?.resureSignedPdfLink : (seller?.pdfLink || seller?.fileUrl);
      window.open(fileUrl, "_blank").focus();
    }else if (isResureSignDoc) {
      let buildData = {
        documentId: seller?.documentId,
        propertyId: URLofferTableJSON?.propertyId,
        ...(selectedData?.offerId ? { offerId: selectedData?.offerId } : {}),
      };
      dispatch(transactionLaneDataHandle.generateresureSignUrl({ buildData,userAuthKey }));
    }  else {
      setLoader(true);
      let buildData = {
        builtForId: URLofferTableJSON?.builtForId ? URLofferTableJSON?.builtForId : currentSellerAgentData?._id,
        key: URLofferTableJSON?.builtForId?URLofferTableJSON?.builtForId:currentSellerAgentData?._id,
        builtForSection: "DOCUMENT",
        signable: sellerOpenOfferTable ? false : true,
        openFor: sellerOpenOfferTable ? "SELLER" : "SELLER_AGENT",
        contractType: seller?.contractType,
        propertyId: URLofferTableJSON?.propertyId,
        ...(selectedData?.offerId ? { offerId: selectedData?.offerId } : {}),
        documentId: seller?.documentId,
        contractId: seller?.contractId,
        token: userAuthKey,
      };
     dispatch(transactionLaneDataHandle.doraDocsUrlShorthandApiCalling({buildData, history}));
    }
  };

  function isSingleWord(text) {
    return text?.trim()?.split(/\s+/)?.length === 1;
  }

const handleSignOffer = () => {
    dispatch(offerTableHandle.acceptOfferViaResureSignFun({ offerTableAuthKey, offerTablePropertyId, documentId: selectedData?.CBSRId, onlySellerAgentSignRequired: true, openFor: sellerOpenOfferTable ? "SELLER" : "SELLER_AGENT", }));
  };

  const MenuItem = (item) => {
    return (
      <Menu size="small">
        <>
          <Menu.Item
            style={{
              color: "#000000",
              fontSize: "14px",
              display: "flex",
              alignItems: "center"
            }}
            icon={
              <CloudUploadOutlined
                style={{
                  color: "#0036F4",
                  fontSize: "20px",
                }}
              />
            }
            key="UPLOAD_OFFER"
            onClick={handleUploadNew}
          >
            Upload updated PDF
          </Menu.Item>
        </>
      </Menu>
    );
  };

  const handleModalCancel = () => {
    setAllData({
      ...allData,
      uploadPdfDoc: false,
    });
  };

  const handleUploadNew = () => {
    setAllData({
      ...allData,
      uploadPdfDoc: true,
    });
  };
  
 
 return (
    <div className={newStyles.documentDetailOuterCOntainer}>
      <div
        className={newStyles.documentBox}
        style={{
          borderColor: seller?.invalidated ? "darkgray" : seller?.RTDInitiator === "SELLER" ? "#3376a8" : "#ffce51",
        }}
      >
        <div
          style={{
            cursor: "pointer",
            textAlign: "center",
            width: "15%",
            pointerEvents: sellerOpenOfferTable ? "none" : "",
            minHeight: "60px"
          }}
        >
        </div>

        <div className={newStyles.documentNameContainer}>
        <div>
   {selectedData?.counterProposalExist &&selectedData.ispdfClone && !selectedData?.sellerAgentSigned&& seller?.contractType === "CBSR"&& <Tooltip onClick={handleSignOffer} title={"Sign Disclosure via RE-Sure Sign"}><SettingOutlined style={{fontSize:"large"}}/></Tooltip>}
        </div>
        <div style={{display: "flex", alignItems: "center"}}>
          <div
            onClick={() => {
              urlShortningForDraft();
            }}
            className={`${newStyles.documentName} ${isSingleWord(doc) ? newStyles.singleWord : ""}`}
            style={{width: "100%",wordWrap: "break-word",
              overflowWrap: "break-word", width: "100%"}}
         >
           <ContractTypeBadge contractType={seller?.contractType}  />
           {isResureSignDoc && (
              <Tooltip title="RE-Sure Sign Document">
                <Image style={{
                objectFit: "contain",
                 height: "40px",
                verticalAlign: "middle",
                marginLeft: "5px",
                marginRight: "-5px",
                display: "inline-block"
              }} height={40} src={ResureSign} preview={false}></Image>
              </Tooltip>
            )}
              <span>{updatedName?.length > 0 ? updatedName : seller?.docCreatedCount > 1 ? `${doc}_${seller.docCreatedCount - 1}` : doc}</span>
             <span style={{marginLeft: "5px"}}>{ispdfClone ? seller?.contractType === "CBSR" ? <FilePdfOutlined /> : "" : ((seller?.isPdf || (seller?.fileType === "PDF")) ? <FilePdfOutlined /> : ((seller?.fileType === "IMAGE") && <FileImageOutlined />))}</span>
             {updatedName?.length > 0 && <div>
              <span style={{ fontSize: "12px" }}>
               ({doc})
              </span>
            </div>}
          </div>
 </div>
          {seller?.contractType !== "CBSR" &&
            (seller?.invalidated ? (
              <Tooltip title={<span style={{ fontSize: isSmallScreen ? 10 : isMediumScreen ? 12 : 14 }}>Invalidated</span>}>
                <ExclamationCircleOutlined style={{ color: "red" }} />
              </Tooltip>
            ) : (
              ""
            ))}
            <span>
              <UploadPdfDoc selectedData={{ ...selectedData, contractId: seller?.contractId, contractType: seller?.contractType, RTDInitiator: "SELLER" }} allData={allData} setAllData={setAllData} handleModalCancel={handleModalCancel} open={allData?.uploadPdfDoc} getCoordinateItem={{ isProperty: "SELLER" }} offerId={selectedData?.offerId} />
              {
                ispdfClone && createOfferContractTypes?.includes(seller?.contractType) && <Dropdown trigger={["click", "hover"]} overlay={<MenuItem />}>
                  <MoreOutlined style={{
                  color: "#0036F4",
                  fontSize: "18px"
                }}/>
                </Dropdown>
              }
            </span>
        </div>

        <div
          style={{
            color: "darkgray",
            textAlign: "center",
            cursor: "pointer",
            width: "15%",
          }}
        >
        </div>
      </div>
    </div>
  );
};

function RtdRow(props) {
  const { contractType  } = props;
  const { updateDocumentLoading } = useSelector((state) => state.rtdTransactionLane);
  const { URLofferTableJSON, offerTableAuthKey, offerTablePropertyId} = useSelector((state) => state.offerTable);

  let sellerOpenOfferTable = URLofferTableJSON?.urlData?.sellerOpenOfferTable;
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery({ maxWidth: 550 });
  const isMediumScreen = useMediaQuery({ minWidth: 551, maxWidth: 850 });
  const [showCoModal, setShowCoModal] = useState(false);

  const checked = {
    showBuyer: props.showBuyer,
    showSeller: props.showSeller,
  };
  
  const handleCheckboxChangeBuyer = (contractType, RTDInitiater, sellerAgentSigned) => {
    // console.log("selectedData", props?.selectedData?.sellerAgentSigned, props?.selectedData);
      if (props?.selectedData?.counterProposalExist && !sellerAgentSigned) {
        if (props.selectedData.ispdfClone && !props?.selectedData?.sellerAgentSigned) {
          setShowCoModal(true);
          return;
        }
      }

  };

  const handleCoConfirmCancel = () => {
    setShowCoModal(false);
  };
  const handleAlreadySignedSend = () => {
    setShowCoModal(false);
    handleCheckboxChangeBuyer(contractType, "SELLER", true);
  };

  const handleSignOffer = () => {
    setShowCoModal(false);
    dispatch(offerTableHandle.acceptOfferViaResureSignFun({ offerTableAuthKey, offerTablePropertyId, documentId: props?.selectedData?.CBSRId, onlySellerAgentSignRequired: true, openFor: sellerOpenOfferTable ? "SELLER" : "SELLER_AGENT", }));
  };
  return (
    <>
      {updateDocumentLoading && (
        <div style={{ position: "fixed", left: "38%", top: "50%", zIndex: "10" }}>
          <Spin size="large" />
        </div>
      )}
      <>
        <Modal width={800} title={<div style={{ color: "#1890ff", fontSize: "18px", fontWeight: "bold", marginBottom: "5px", textAlign: "center", textDecoration: "underline" }}>Seller Agent Signature Required</div>} size="100px" visible={showCoModal} onCancel={handleCoConfirmCancel} footer={null}>
          <div className={newStyles.signOfferConfirmationMsgDiv}>
            <div>
              <MessageTwoTone style={{ fontSize: "24px" }} />
            </div>
            <div style={{ fontSize: "16px", color: "#777" }}>
            Seller agent should sign the broker disclosure section of the Contract to Buy and Sell Real Estate before the Counterproposal is sent to the buyer's agent.
            </div>
          </div>
          <div className={newStyles.signOfferConfirmationBtns}>
            <Button onClick={handleSignOffer}>Sign Disclosure via RE-Sure Sign</Button>
            <Button type="primary" onClick={handleAlreadySignedSend}>
            I have signed the disclosure, Send
            </Button>
          </div>
        </Modal>


        {contractType !== "TR" ? (
          <div className={newStyles.eachDocumentRowContainer}>
       
            <SellerComp {...props} sellerOpenOfferTable={sellerOpenOfferTable} checked={checked} handleCheckboxChangeBuyer={handleCheckboxChangeBuyer} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen}/>

            <DetailComp sellerOpenOfferTable={sellerOpenOfferTable} seller={props} doc={props?.isResureSignDoc ? props.documentName :props.contractName || props.fileName} role={props.tags} selectedData={props.selectedData} ispdfClone={props.ispdfClone} userAuthKey={props.userAuthKey} handleCheckboxChangeBuyer={handleCheckboxChangeBuyer} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen} allBuyerAgentData={props?.allBuyerAgentData}   isResureSignDoc={props?.isResureSignDoc} updatedName={props?.updatedName || null}/>

            <BuyerComp sellerOpenOfferTable={sellerOpenOfferTable} {...props} checked={checked} handleCheckboxChangeBuyer={handleCheckboxChangeBuyer} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen} />
          </div>
        ) : null}
      </>
    </>
  );
}

export default RtdRow;
